import React, { Component } from 'react';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  Toast,
  ToastBody,
  ToastHeader,
  ModalHeader,
} from 'reactstrap';
import { saveFulfilmentDetails } from '../../services/api/customer-support';

class UserBankDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmSave: false,
      saving: false,
      response: {
        show: false,
        message: '',
        color: 'success',
      },
      updateDocumentModal: false,
      onlyDocumentUpdate: Boolean(this.props.userDetail?.[0]?.onlyDocumentUpdate),
      documentProof: null,
      isCheckboxChecked: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { response } = this.state;
    if (response.show && !prevState.response.show) {
      this.setTimeoutForResponsePopup();
    }
  }

  setTimeoutForResponsePopup() {
    this.clearTimeout = setTimeout(() => {
      this.setState({
        response: {
          show: false,
        },
      });
      this.clearTimeout = null;
    }, 3000);
  }

  saveFulfilmentDetails = () => {
    const bankAccount = document.querySelector('#bankAccount').value;
    const ifscCode = document.querySelector('#ifscCode').value;
    const file = document.querySelector('#documentProof').files[0];
    if (!bankAccount || !ifscCode) {
      this.setState({
        response: {
          show: true,
          message: 'Please enter all fields before saving',
          color: 'danger',
        },
      });
      return;
    }
    this.setState({
      response: {
        show: false,
      },
      saving: true,
    });
    const formData = new FormData();
    formData.append('userId', this.props.userId);
    formData.append('accountNumber', bankAccount);
    formData.append('ifsc', ifscCode);
    formData.append('file', file);
    saveFulfilmentDetails(formData)
      .then((res) => {
        if (res.message === 'success') {
          this.setState({
            response: {
              show: true,
              message: 'Account details saved successfully',
              color: 'success',
            },
          });
          this.props.getUpdatedDetails();
        } else {
          this.setState({
            response: {
              show: true,
              message: res.errorMessage || 'Failed to save account details',
              color: 'danger',
            },
          });
        }
      })
      .catch((err) => {
        this.setState({
          response: {
            show: true,
            message: err.errorMessage || 'Failed to save account details',
            color: 'danger',
          },
        });
      })
      .finally(() => {
        this.setState({
          saving: false,
          confirmSave: false,
        });
      });
  };

  confirmSave = () => {
    this.setState({
      confirmSave: true,
    });
  };

  openUpdateDocumentModal = () => {
    this.setState({
      updateDocumentModal: true
    });
  };

  closeUpdateDocumentModal = () => {
    this.setState({
      updateDocumentModal: false,
      documentProof: null,
      isCheckboxChecked: false
    });
  };

  handleCheckboxChange = () => {
    this.setState(prevState => ({
      updateDocumentModal: true,
      isCheckboxChecked: true
    }));
  };

  updateBankDetails = () => {
    if (!this.state.documentProof) {
      this.setState({
        response: {
          show: true,
          message: 'Please select a document to upload',
          color: 'danger'
        }
      });
      return;
    }

    this.setState({ saving: true });

    const formData = new FormData();
    formData.append('userId', this.props.userId);
    formData.append('accountNumber', this.props.userDetail[0].userBankAccount);
    formData.append('ifsc', this.props.userDetail[0].userIfscCode);
    formData.append('file', this.state.documentProof);
    formData.append('onlyDocumentUpdate', this.state.onlyDocumentUpdate);

    saveFulfilmentDetails(formData)
      .then((res) => {
        this.setState({
          response: {
            show: true,
            message: 'Document updated successfully',
            color: 'success'
          },
          isCheckboxChecked: false
        });
        this.closeUpdateDocumentModal();
      })
      .catch((err) => {
        this.setState({
          response: {
            show: true,
            message: err.message || 'Failed to update document',
            color: 'danger'
          }
        });
      })
      .finally(() => {
        this.setState({
          saving: false
        });
      });
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ 
        documentProof: file,
        response: {
          show: false,
          message: '',
          color: 'success'
        }
      });
    }
  };

  render() {
    const { response, saving, updateDocumentModal, isCheckboxChecked } = this.state;
    const userDetail = this.props.userDetail?.[0];

    if (!userDetail) {
      return <div>No user details available</div>;
    }

    return (
      <>
        <Modal isOpen={updateDocumentModal}>
          <ModalHeader>Update Bank Details</ModalHeader>
          <ModalBody>
            <Toast isOpen={response.show}>
              <ToastHeader icon={response.color}>Response</ToastHeader>
              <ToastBody>{response.message}</ToastBody>
            </Toast>
            <Form>
              <FormGroup>
                <Label for="bankAccount">Bank Account</Label>
                <Input 
                  type="text" 
                  name="bankAccount" 
                  id="bankAccount" 
                  value={userDetail.userBankAccount || ''} 
                  disabled 
                  className="mb-3"
                />
              </FormGroup>
              <FormGroup>
                <Label for="ifsc">IFSC Code</Label>
                <Input 
                  type="text" 
                  name="ifsc" 
                  id="ifsc" 
                  value={userDetail.userIfscCode || ''} 
                  disabled 
                  className="mb-3"
                />
              </FormGroup>
              <FormGroup>
                <Label for="documentProof">Upload New Document</Label>
                <Input
                  type="file"
                  accept="image/*,.pdf"
                  name="documentProof"
                  id="documentProof"
                  className="mb-3"
                  onChange={this.handleFileChange}
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.closeUpdateDocumentModal} disabled={saving}>
              Cancel
            </Button>
            <Button color="primary" onClick={this.updateBankDetails} disabled={saving}>
              {saving ? 'Updating...' : 'Update'}
            </Button>
          </ModalFooter>
        </Modal>
        <div className={'row'}>
          <div className={'col-md-12'}>
            <Toast isOpen={response.show}>
              <ToastHeader icon={response.color}>Response</ToastHeader>
              <ToastBody>{response.message}</ToastBody>
            </Toast>
            <Form>
              <FormGroup inline>
                <Label for="bankAccount" sm={5}>
                  Bank Account
                </Label>
                <Col sm={7}>
                  <Input type="text" name="bankAccount" id="bankAccount" />
                </Col>
              </FormGroup>
              <FormGroup inline>
                <Label for="ifscCode" sm={5}>
                  IFSC
                </Label>
                <Col sm={7}>
                  <Input type="text" name="ifscCode" id="ifscCode" />
                </Col>
              </FormGroup>
              <FormGroup inline>
                <Label for="documentProof" sm={5}>
                  Document Proof
                </Label>
                <Col sm={7}>
                  <Input
                    type="file"
                    accept="image/*,.pdf"
                    name="documentProof"
                    id="documentProof"
                  />
                </Col>
              </FormGroup>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '1rem' }}>
                <Button
                  color="info"
                  onClick={this.confirmSave}
                >
                  Save
                </Button>
                <FormGroup check style={{ margin: 0 }}>
                  <Label check>
                    <Input 
                      type="checkbox" 
                      name="updateDocument" 
                      id="updateDocument"
                      checked={isCheckboxChecked}
                      onChange={this.handleCheckboxChange}
                    />
                    Update Bank Document
                  </Label>
                </FormGroup>
              </div>

              {/* Create a checkbox where it should ask update document for existing account on click of this checkbox backend api will be called and the existing bank account details will be prefilled in the above filed */}
            </Form>
          </div>
        </div>
        <Modal isOpen={this.state.confirmSave}>
          <ModalBody>Do you want to Add this account?</ModalBody>
          <ModalFooter>
            <Button
              disabled={saving}
              color="primary"
              onClick={this.saveFulfilmentDetails}
            >
              {saving ? 'Saving' : 'Save'}
            </Button>
            <Button
              color="secondary"
              disabled={saving}
              onClick={() => {
                this.setState({
                  confirmSave: false,
                });
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default UserBankDetails;
